import { useDispatch, useSelector } from "react-redux";
import TrackingComp from "../../components/Doctor/Tracking";
import { useEffect } from "react";
import { getDoctorDetails } from "../../redux/Thunk/Doctor/DoctorThunks";

const Tracking = () => {
  const doctor = useSelector((state) => state?.doctor?.doctorDetails?.doctor);
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      dispatch(getDoctorDetails(token));
    }
  }, [dispatch]);

  return (
    <section>
      {doctor?.SID ? (
        <TrackingComp doctorId={doctor?.DID} />
      ) : (
        <div className="min-h-[calc(100vh_-_80px)] flex items-center justify-center py-4 pr-4 w-full">
          <h2 className="text-center">
            You are not connected with any store!!
          </h2>
        </div>
      )}
    </section>
  );
};

export default Tracking;
